import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

console.log('Hello World! (from create-block-advantages block)');


function initializeAOSForBlock(blockElement) {
	AOS.init({
		duration: 1200,
		offset: 50,
		container: blockElement,
	});
}
document.querySelectorAll('.wp-block-create-block-advantages').forEach(block => {
	initializeAOSForBlock(block);
});

document.addEventListener('DOMContentLoaded', function () {
	let swiperInstance = null;
	let firstSlideRemoved = false;
	const initSwiper = () => {
		const swiperContainer = document.querySelector('.advantages-swiper');
		const firstSlide = document.querySelector('.swiper-slide:first-child');
		if (window.innerWidth < 1200) {
			if (firstSlide && !firstSlideRemoved) {
				firstSlide.style.display = 'none';
				firstSlideRemoved = true;
			}
			if (!swiperInstance) {
				swiperInstance = new Swiper('.advantages-swiper', {
					loop: true,
					slidesPerView: 1.3,
					spaceBetween: 40,
					modules: [Navigation, Pagination],
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						1024: {
							slidesPerView: 2.5,
							spaceBetween: 20
						},
						768: {
							slidesPerView: 1.5,
							spaceBetween: 10
						},
						0: {
							slidesPerView: 1.4,
							spaceBetween: 25
						}
					}
				});
			}
		} else {
			if (swiperInstance) {
				swiperInstance.destroy();
				swiperInstance = null;
			}
			if (firstSlide && firstSlideRemoved) {
				firstSlide.style.display = '';
				firstSlideRemoved = false;
			}
		}
	};
	initSwiper();
	window.addEventListener('resize', initSwiper);
});
